import React from "react"

export default class SearchTitle extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		if (this.props.total_pages === 0) {
			return null;
		}
		
		return (
			<div className={"search-title " + this.props.size}>
			  {this.renderCheckbox()}
			  {this.renderPreviewImage()}
				{this.renderName()}
				{/*this.renderLocation()*/}
				{/*this.renderType()*/}
				{/*this.renderLastModified()*/}
				{/*this.renderActions()*/}
			</div>
		)
	}

	renderActions() {
		return (
			<div className="action-ellipsis">
				<span className="fa fa-bars"></span><span className="fa fa-sort-desc"></span>
			</div>
		)
	}

	renderCheckbox() {
		return (
			<div className="checkbox-col">
				<div className="value">{' '}</div>
			</div>
		)
	}

	renderLastModified() {
		return (
			<div className="last-modified">
				<div className="value">Modified</div>
			</div>
		)
	}

	renderLocation() {
		return (
			<div className="location">
				<div className="value">Location</div>
			</div>
		)
	}

	renderName() {
		return (
			<div className="name">
				<div className="value">Name</div>
			</div>
		)
	}

	renderPreviewImage() {
		return (
			<div className="preview-image">
			</div>
		)
	}

	renderType() {
		return (
			<div className="type">
				<div className="value">Type</div>
			</div>
		)
	}	

}